export default "__VITE_ASSET__D8HsL2hv__"